import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  response: null,
  error: null,
};

const updateQuizSlice = createSlice({
  name: "updateQuiz",
  initialState,
  reducers: {
    updateQuizRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.response = null;
    },
    updateQuizRequestSuccess: (state, action) => {
      state.loading = false;
      state.response = action.payload;
    },
    updateQuizRequestError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  updateQuizRequest,
  updateQuizRequestSuccess,
  updateQuizRequestError,
} = updateQuizSlice.actions;

export default updateQuizSlice.reducer;
